// extracted by mini-css-extract-plugin
module.exports = {"modal-close-btn":"ModalClose_modal-close-btn__LXxAh"};